<div class="modal-header">
  <h2 class="__title">
    SafeProx Report for 
    <b> {{ data?.workerFullName || data?.workerSiteNumber }}</b>
  </h2>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
  <hr class="simple-separator">
</div>
<div class="modal-body">

  <div class="inner-modal-body">
    <form [formGroup]="reportForm" (ngSubmit)="onSubmit(reportForm)">
      <div class="date-range-container">
        <h4 class="date-range-title">
          Date Range
        </h4>
        <small class="date-range-subtitle">
          Select the start and end dates you wish to capture.
        </small>

        <div class="form-container">
          <div class="form-container-item">
            <div class="form-group has-float-label date-picker" >
              <input type="text" class="form-control"
                [matDatepicker]="picker1"
                name="startDate"
                formControlName="startDate"
                (dateChange)="dateChange($event)"
                placeholder=" " >
              <mat-datepicker disabled="false" #picker1></mat-datepicker>
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <label floatingLabel> 
                {{ "readers.startDate" | translate }} 
              </label>
    
            </div>
          </div>

          <div class="form-container-item">
            <div class="form-group has-float-label date-picker" >
              <input type="text" class="form-control"
                [matDatepicker]="picker2 "
                name="endDate"
                (dateChange)="dateChange($event)"
                formControlName="endDate"
                placeholder=" " >
              <mat-datepicker disabled="false" #picker2></mat-datepicker>
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <label floatingLabel> 
                {{ "readers.endDate" | translate }} 
              </label>
    
            </div>
          </div>
          
        </div>
        <ng-container *ngIf="displayWarning">
          <eyrus-banner-alert 
            (closed)="alertClosed()"
            [type]="'error'">
            {{ warningMessage | translate }}
          </eyrus-banner-alert>
        </ng-container>
      </div>
      <div class="date-range-description">
        Your report will only display contact tracing events within your company.
      </div>

      <div class="date-range-footer">

        <p class="text-left description">
          The General Contractor will receive an anonymous report without your employee’s <br>
          personal information.  
        </p>
        
        <div class="button-holder text-left">
            <button mat-stroked-button color="primary"
            (click)="cancel()">
              <span class="capitalize"> {{ "common.cancel" | translate }} </span>
            </button>
            <button mat-raised-button type="button" 
            type="submit"
            [disabled]="loading"
            color="primary">
              <span *ngIf="!loading"> {{ "workforce.report.runReport" | translate }}  </span>
              <span *ngIf="loading">
                <i class="fas fa-circle-notch fa-2x fa-spin m-t-xs"></i>
              </span> 
            </button>
        </div>
      </div>
    </form>
  </div>
</div>